<div class="form-page" [formGroup]="form">
    @if (!entity?.id) {
    <section class="block">
        <h3>Novo cadastro</h3>
        <div class="fields new">
            <mat-form-field appearance="outline" class="name">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="name" required />
            </mat-form-field>
            <mat-form-field appearance="outline" class="code">
                <mat-label>Código</mat-label>
                <input matInput formControlName="code" />
            </mat-form-field>
            <mat-form-field appearance="outline" class="email">
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="email" type="email" />
            </mat-form-field>
        </div>
    </section>
    } @else {
    <!-- Nome/código já estão no cabeçalho — evita duplicar. -->
    <input type="hidden" formControlName="name" />
    <input type="hidden" formControlName="code" />

    <section class="block compact">
        <h3>Contato e status</h3>
        <div class="edit-row">
            <mat-form-field appearance="outline" class="email">
                <mat-label>E-mail</mat-label>
                <input matInput formControlName="email" type="email" />
            </mat-form-field>
            <div class="status-actions">
                <span class="status-pill" [class.on]="entity?.active !== false" [class.off]="entity?.active === false">
                    {{ entity?.active === false ? 'Inativo' : 'Ativo' }}
                </span>
                <button
                    type="button"
                    mat-stroked-button
                    color="primary"
                    (click)="statusChange.emit(true)"
                    [disabled]="entity?.active === true"
                >
                    Ativar
                </button>
                <button
                    type="button"
                    mat-stroked-button
                    color="warn"
                    (click)="statusChange.emit(false)"
                    [disabled]="entity?.active === false"
                >
                    Desativar
                </button>
            </div>
        </div>
    </section>
    }
</div>
